var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Header2'),_c('Banner'),_c('RemoveGameList'),_c('Age'),_c('Report'),_c('ReturnTop'),_c('Footer'),_c('Login',{ref:"login",staticClass:"login"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }